import React from "react";
import { LifeBuoy } from "lucide-react";
import { useTranslation } from "../../../context/Internationalization";
import { useConsoleHelpLinks } from "../../../context/ConsoleHelpLinksContext";
import { getConsoleHelpUrl } from "../../../utility/consoleHelpLinks";
import { buttonVariants } from "../../../shadcn/components/ui/button";
import { cn } from "../../../shadcn/lib/utils";

export default function PageHelp({ pageKey }) {
  const { lang, t } = useTranslation();
  const help = useConsoleHelpLinks();
  const url = getConsoleHelpUrl(help?.configuration, pageKey, lang);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(buttonVariants({ variant: "link" }), "h-auto self-start p-0")}
    >
      <LifeBuoy aria-hidden="true" />
      {t("page_help_need_help")}
    </a>
  );
}
